// extracted by mini-css-extract-plugin
export default {"container":"message_container__9rtsb","newbie":"message_newbie__kp9WY","balanceNegative":"message_balanceNegative__29Zeh","onlyTrial":"message_onlyTrial__yp3ry"};